module.exports = (__parcel__import__("22zr2")).then(() => parcelRequire('lmhgI'));